import Swal from "sweetalert2";
import { formatearFechaDeServidor, formatearTiempo } from "../../../../utilidades/formateos";
import api from "../../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY



export const getDataEditTiket = (id, setStatus) => {
    api.get(`${urlApi}/administracion/gasoline/getTicketGasolineById/${id}`).then((res) => {
       
        setStatus({
            fecha: { value: formatearFechaDeServidor(res.data.FECHA), validationType: "empty" },
            hora: { value: formatearTiempo(res.data.FECHA, res.data.TIEMPO), validationType: "empty" },
            unidad: { value: res.data.UNIDAD, validationType: "empty" },
            gasolinera: { value: res.data.GASOLINERA, validationType: "empty" },
            folio: { value: res.data.FOLIO_TICKET, validationType: "empty" },
            kilometraje: { value: res.data.KILOMETRAJE, validationType: "empty" },
            tipoCombustible: { value: { name: res.data.COMBUSTIBLE, code: res.data.COMBUSTIBLE }, validationType: "empty" },
            litros: { value: res.data.LITROS, validationType: "empty" },
            precio: { value: res.data.PRECIO, validationType: "empty" },
            km_recorrido: { value: res.data.KM_RECORRIDO, validationType: "optional" }
        })
    })
        .catch((error) => {
            console.log("error", error);
        })
}

export const getGasolineras = (setStatus) => {
    api.get(`${urlApi}/administracion/gasoline/getProveedores`).then((res) => {
        console.log('get gasolina',res.data)
        setStatus(res.data);
    })
        .catch((error) => {
            console.log("error", error);
        })
}

/**
 * Agrega un ticket de gasolina
 * @param {Object} data - Información del ticket
 * @returns {Promise<string>} Mensaje de confirmación
 * @throws {Error} Error normalizado
 */
export const agregarTicketFunction = async (data) => {
    if (!data || typeof data !== 'object') {
        throw new Error('Datos inválidos para agregar el ticket');
    }

    try {
        const { data: responseData } = await api.post(
            `${urlApi}/administracion/gasoline/addTicketGasoline`,
            data
        );

        return responseData?.message ?? 'Ticket agregado correctamente';
    } catch (err) {
        const errorMessage =
            err?.response?.data?.message ||
            err?.message ||
            'Error inesperado al agregar el ticket';

        throw new Error(errorMessage);
    }
};


/**
 * Actualiza un ticket de gasolina
 */
export const subirInfoActualizada = async (payload) => {
    try {
        const { data } = await api.put(
            `${urlApi}/administracion/gasoline/updateTicketGasoline`,
            payload
        );

        return data;
    } catch (err) {
        const message =
            err?.response?.data?.message ||
            'Error al actualizar la información del ticket';

        throw new Error(message);
    }
};
